import React from "react";

import { Alert, FormControl, MenuItem, Select } from "@mui/material";

import {
    PaddedContent,
    CreationFooter,
} from "components/organisms/CreationModal";

import useTrackerStep from "./useTrackerStep";

export { useTrackerStep };

// `CreationFooter` is a JSX forwardRef; TS infers empty props for it.
const Footer = CreationFooter as React.ComponentType<any>;

/**
 * Body of the "attach to tracker" step: success notice + tracker select.
 * Pair with `TrackerStepFooter` in the modal footer; both read from
 * `useTrackerStep`.
 */
export const TrackerStepContent = ({ trackers, trackerStep }: any) => {
    const { isDestination, selectedTracker, setSelectedTracker } = trackerStep;

    return (
        <PaddedContent>
            <Alert severity="info">
                {isDestination ? (
                    <>
                        Your destination has been successfully created but is
                        not yet attached to a tracker. To ensure signals are
                        transmitted, please select a tracker and attach your
                        destination.
                    </>
                ) : (
                    <>
                        Your source has been successfully created but is not yet
                        attached to a tracker. To ensure signals are
                        transmitted, please select a tracker and attach your
                        source.
                    </>
                )}
            </Alert>

            <FormControl fullWidth>
                <Select
                    value={selectedTracker}
                    label="Tracker"
                    onChange={({ target: { value } }) =>
                        setSelectedTracker(value)
                    }
                    fullWidth
                    data-cy="tracker-step-select"
                >
                    {trackers?.map((tracker: any) => (
                        <MenuItem key={tracker?.id} value={tracker?.id}>
                            {tracker?.tracker_name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </PaddedContent>
    );
};

/** "Create new tracker" (left) + "Attach to tracker" (right) in the shared footer style. */
export const TrackerStepFooter = ({ language, trackerStep }: any) => (
    <Footer
        onSecondary={trackerStep.createNewTracker}
        secondaryLabel={
            language?.buttons?.create_new_tracker ?? "Create new tracker"
        }
        isCancelDisabled={trackerStep.isLoading}
        onSubmit={trackerStep.addToTracker}
        submitLabel={
            language?.buttons?.attach_to_tracker ?? "Attach to tracker"
        }
        isSubmitDisabled={!trackerStep.selectedTracker}
        isSubmitLoading={trackerStep.isLoading}
        submitTestId="tracker-step-submit"
    />
);
